import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Row, Col, Form, Input, Button } from "reactstrap";
import axios from "../../../Utils/axios";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import classes from "../../Login/LoginForm.module.css";

export default function ForgotPasswordReset() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { t } = useTranslation(); // ✅ Hook i18n

  if (!token) {
    return <p className="text-center mt-5">{t("invalid_link")}</p>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (password !== confirmPassword) {
      toast.error(t("passwords_not_match"));
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`/confirm_reset_password?token=${token}`, {
        password,
        confirm_password: confirmPassword,
      });

      if (response.data.status === "success") {
        toast.success(response.data.message || t("password_reset_success"));
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error(response.data.message || t("generic_error"));
      }
    } catch (err) {
      const responseData = err?.response?.data;

      if (responseData?.error) {
        Object.values(responseData.error).forEach((messages) => {
          messages.forEach((msg) => toast.error(msg));
        });
      } else {
        toast.error(responseData?.message || t("generic_error"));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className="justify-content-center mt-5">
      <ToastContainer />
      <Col md={6}>
        <h4 className={classes.headerTitle}>{t("reset_password_title")}</h4>
        <Form onSubmit={handleSubmit}>
          <Input
            type="password"
            placeholder={t("new_password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Input
            type="password"
            placeholder={t("confirm_password")}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="mt-3"
            required
          />
          <div>
          <Button type="submit"             className={`btn ${classes.buttonStyle} w-100`}
 disabled={loading}>
            {loading ? t("sending") : t("reset")}
          </Button></div>
        </Form>
      </Col>
    </Row>
  );
}